<template>
  <el-dialog :title="$t('ssrManage.announce')" :visible="isShow" width="45%" @close="cancel('showIssueDialog')">
    <div>
      <el-form ref="form" :model="formData">
        <div>{{$t('ssrManage.round')}}：Round {{roundNumber | romanNum}}</div>
        <div>{{$t('ssrManage.roundEndDate')}}：
          <el-form-item prop="roundEndDate" :rules="{required: true,message: '请输入'}">
            <el-date-picker :picker-options="{disabledDate:(val)=>val<new Date(new Date()-1000*60*60*24)}" type="date" v-model="formData.roundEndDate" />
          </el-form-item>
        </div>
        <div style="margin-top:15px;">BCC</div>
        <el-table :data="formData.bccList" ref="bccList" border highlight-current-row>
          <!--供应商名称-->
          <el-table-column prop="supplierName" :label="$t('ssrManage.supplierName')">
            <template slot-scope="scope">
              <el-form-item :prop="`bccList[${scope.$index}].name`" :rules="{required: true,message: '请输入'}">
                <el-input v-model="scope.row.name"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <!--Email-->
          <el-table-column prop="email" label="Email">
            <template slot-scope="scope">
              <el-form-item :prop="`bccList[${scope.$index}].email`" :rules="{type:'email',required: true,message: '请输入邮箱地址'}">
                <el-input v-model="scope.row.email"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column width="100">
            <template slot-scope="scope" v-if="scope.row.canDel">
              <el-button type="primary" @click="formData.bccList.splice(scope.$index,1)">delete</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-link type="primary" @click="addEmail('BCC')">Add</el-link>
        <div style="margin-top:15px;">TO</div>
        <el-table :data="formData.toList" ref="toList" border highlight-current-row>
          <!--供应商名称-->
          <el-table-column prop="supplierName" :label="'Name'">
            <template slot-scope="scope">
              <el-form-item :prop="`toList[${scope.$index}].name`" :rules="{required: true,message: '请输入'}">
                <el-input v-model="scope.row.name"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <!--Email-->
          <el-table-column prop="email" label="Email">
            <template slot-scope="scope">
              <el-form-item :prop="`toList[${scope.$index}].email`" :rules="{type:'email',required: true,message: '请输入邮箱地址'}">
                <el-input v-model="scope.row.email"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column width="100">
            <template slot-scope="scope">
              <el-button type="primary" @click="formData.toList.splice(scope.$index,1)">delete</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-link type="primary" @click="addEmail('TO')">Add</el-link>
        <div style="margin-top:15px;">CC</div>
        <el-table :data="formData.ccList" ref="ccList" border highlight-current-row>
          <!--供应商名称-->
          <el-table-column prop="supplierName" :label="'Name'" column-key="">
            <template slot-scope="scope">
              <el-form-item :prop="`ccList[${scope.$index}].name`" :rules="{required: true,message: '请输入'}">
                <el-input v-model="scope.row.name"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <!--Email-->
          <el-table-column prop="email" label="Email">
            <template slot-scope="scope">
              <el-form-item :prop="`ccList[${scope.$index}].email`" :rules="{type:'email',required: true,message: '请输入邮箱地址'}">
                <el-input v-model="scope.row.email"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column width="100">
            <template slot-scope="scope">
              <el-button type="primary" @click="formData.ccList.splice(scope.$index,1)">delete</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-link type="primary" @click="addEmail('CC')">Add</el-link>
        <div class="foot-btn" style="padding-top: 10px;text-align: center">
          <el-button type="primary" @click="confirmMethod">{{ $t('ssrManage.announce') }}</el-button>
          <el-button @click="cancel('showIssueDialog')">{{ 'Cancel' }}</el-button>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import commonMethods from "@/utils/commonMethods";
import { Message } from "element-ui";
import commonFun from "@/utils/commonFun";
import { apiService } from "@/api/ssr-manage/ssr-manage";

export default {
  extends: commonMethods,
  components: {},
  computed: {
    roundTitle() {
      let num = commonFun.toChinesNum(this.roundNumber);
      return this.$t("ssrManage.roundTitle", [num]);
    }
  },
  props: {
    ssrId: Number,
    isShow: {
      type: Boolean,
      default: true
    },
    roundNumber: Number,
    createFun: {
      type: Function,
      default: function () {
      }
    },
    mailTos: Array,
    mailCcs: Array,
    mailBccs: Array,
  },
  watch: {
    mailTos(val) {
      this.formData.toList = this.mailTos;
    },
    mailCcs(val) {
      this.formData.ccList = this.mailCcs;
    },
    mailBccs(val) {
      this.formData.bccList = this.mailBccs;
    }
  },
  data() {
    return {
      totalCount: 0,
      statusList: [], // 状态列表
      queryCondition: {
        size: 10,
        current: 1,
        dunsCode: null,
        supplierName: null,
        supplierType: null,
        status: null,
        sapSupplierCode: null
      },
      formData: {
        roundEndDate: null,
        bccList: [],
        toList: [],
        ccList: [],
      },
      round: '第一轮'
    };
  },
  mounted() {
    //默认值当前日期+14天
    const myDate = new Date();
    this.formData.roundEndDate = myDate.setDate(myDate.getDate() + 14);
  },
  methods: {
    addEmail(type) {
      if (type == 'BCC') {
        this.formData.bccList.push({ name: '', email: '', canDel: true });
      } else if (type == 'TO') {
        this.formData.toList.push({ name: '', email: '' });
      } else if (type == 'CC') {
        this.formData.ccList.push({ name: '', email: '' });
      }
    },
    confirmMethod() {
      let that = this;
      if (commonFun.isEmpty(this.formData.bccList) || commonFun.isEmpty(this.formData.toList)) {
        Message({ message: '请完成填写BCC、TO的对象。', type: "warning" });
      } else {
        this.$refs.form.validate((valid) => {
          if (valid) {
            apiService.issue({
              ttSsrId: that.ssrId,
              deadline: that.formData.roundEndDate,
              tos: that.formData.toList,
              ccs: that.formData.ccList,
              bccs: that.formData.bccList
            }).then(value => {
              Message.success('Operate Success');
              that.$emit("issued");
            });
          }
        })
      }
    }
  }
};
</script>

<style scoped lang="scss"></style>
